/**
 * 该配置文件打包编译之后内容无法修改， 打包之后需要修改的配置统一放置在static/config/app-config.js
 */

const Local = window.location;
// const host = `${Local.protocol}//${ Local.port == '3000' ? Local.hostname +':8080' : Local.host }`;
const host = APPCONFIG.IP;
const geohost = APPCONFIG.DisIp;
const gatewayhost = APPCONFIG.CacheMap;

const Sites = {
    Geoesbmengine: host + "/skygeoesbmengine",
    GWebframe: host + "/skywebframe",
    Map: host + '/map',
    serpool: host + "/serpool",
    Cas: host + '/skycas',
}
module.exports = {
    archive:{
        location: APPCONFIG.SgsHost + '/archive',
      },
    // 行为日志
    logBehavior: {
        location: host
    },
    SdmmetaData: {
        location: host + '/sdmmetadata'
    },
    ServiceConfig: {
        httpproxy: Sites.GWebframe + "/biz/httpproxy/httpproxy.jsp"
    },
    Archive: {
        location: host + '/archive',
    },
    SgsConfig: {
        ticket: Sites.Cas + "/autoLogin?username="+ APPCONFIG.SgsGuest.username +"&service="+host+"/map/index.html#/map",
        GetCatalogFormt: Sites.Geoesbmengine + "/services/servicemanager/catalogformt/all.json",
        GetServiceNodes: Sites.Geoesbmengine + "/services/catalog/resource/service",
        GetCatalogNodes: Sites.Geoesbmengine + "/services/catalog/gategoty/view.json",
        GetResourceNodes: Sites.Geoesbmengine + "/services/catalog/resource/view.json",
        
        GetRootCode: Sites.Geoesbmengine + "/services/servicemanager/datacatalog/child.json",
        GetTradeCatalog: Sites.Geoesbmengine + "/services/servicemanager/datacatalog/tree/code",
        GetTradeResource: Sites.Geoesbmengine + "/services/servicemanager/datacatalog/resource/code/query.json",
      
        SearchResource: Sites.Geoesbmengine + "/services/resource/data/full",
        SearchResourceHistory: Sites.Geoesbmengine + "/services/resource/data/searchrecord.json",//智能推荐的搜索历史数据接口
        SearchResourceHot: Sites.Geoesbmengine + "/services/log/system/topchart/services/recommendation.json",//智能推荐的热门数据的查询接口
        SearchResourceHistoryDelete: Sites.Geoesbmengine + "/services/resource/data/searchrecord/deleteall.json",//智能推荐的搜索历史数据的删除接口
        SearchResourceRecommend: Sites.Geoesbmengine + "/services/resource/data/searchresult/recommendation.json",//智能推荐的相关服务推荐的接口
        SearchFullResource: Sites.Geoesbmengine + "/services/resource/data/full",
        GetRootTheme: Sites.Geoesbmengine + "/services/servicemanager/datacatalog/root.json",
        GetChildTheme: Sites.Geoesbmengine + "/services/servicemanager/datacatalog/tree",
        GetServiceDate: Sites.Geoesbmengine + "/services/resource/data/serinfo",
        GetSpecials: Sites.Geoesbmengine + "/services/servicemanager/special/specname.json",
        
        StyleLayer: Sites.Map + "/services/stylelayer", //地图定制增加/更新接口
        getStyleLayer: Sites.Map + "/services/stylelayer/getByServiceId", //查询风格图层
        StyleMap: Sites.Map + "/services/stylemap",
        getDatasetsByDataSourceId: Sites.serpool + "/services/tree/datasetinfo.json",
        getDatasetInfoByDatasetName: Sites.serpool + "/services/tree",
        GetSerPoolEntityTreeRoot: Sites.serpool + "/services/tree/root.json",
        getSerPoolChildTheme: Sites.serpool + "/services/tree/child/datasource.json",
        getEntityServiceList: Sites.serpool + "/services/service/servicelist.json",
        getAllFields: Sites.Geoesbmengine + "/services/datameta/getAllfields", //获取属性服务所有字段
        fiddlerBehavior: Sites.Geoesbmengine + "/services/log/behaviorStat/fiddlerBehavior.json", //行为监控
        uploadSurveyPoint: Sites.Geoesbmengine + "/services/surveypoint/import.json", //上传勘测定界坐标（云南）
        MetadataTemplate: host + "/servicemanager/static/metadata/template/res-metadata-template.xml"
    },
    Geoesbmengine: {
        location: host + '/skygeoesbmengine',
    },
    Gateway: {
        location: gatewayhost + '/convert'
    },
    Map: {
        location: host + '/map',
    },

    SDE: {
        location: APPCONFIG.AnalysisHost + '/sde'
    },

    DFC: {
        location: host + '/dfc',
        transformUrl: host + '/dfc/services/prjCoordSysTransform/transformpoints/inverse.json',
        transformForward: host + '/dfc/services/prjCoordSysTransform/transformpoints/forward.json',
        GetDataByDatasetid: host + '/dfc/services/sgssfs/',
        transGeojsonToDataset: host + '/dfc/services/spatial/exportDs.json',
    },
    GeoEntity: {
        location: geohost + '/geoentity'
    },
    Usercenter: {
        location: host + '/webmain/#/subpage?index='
    },
    Cas: {
        location: host + '/skycas'
    },
    Nav: {
        location: host + '/nav'
    },
    Editmanager: {
        location: host + '/editmanager'
    },
    Webframe: {
        location: Sites.GWebframe
    },
    Quota: {
        location: APPCONFIG.QuotaHost + '/quotamanager'
    },
    Serpool: {
        location: host + '/serpool'
    },
    Mule: {
        location: APPCONFIG.MuleHost + '/geoesb/proxy/'
    },
    IcacheMap: {
        location: APPCONFIG.CacheMap + "/icachemap"
    },
    Condition: {
        greater: "大于",
        greater_eq: "大于等于",
        less: "小于",
        less_eq: "小于等于",
        eq: "等于",
        like: "模糊",
        equals: "等于",
        include: "包含",
        notinclude: "不包含"
    },
}



// WEBPACK FOOTER //
// ./src/config/app-config.js